<template>
    <b-card>
        <b-alert variant="danger" :show="showAlert">
            {{ alert }}
        </b-alert>
        <b-alert variant="success" :show="showSuccessAlert">
            {{ alert }}
        </b-alert>
        <b-form @submit.prevent="setPoint">
            <b-form-group :label="$t('kkm.pointTitle')" label-cols-sm="3">
                <b-form-input v-model="formData.salePointTitle" required></b-form-input>
            </b-form-group>
            <b-form-group :label="$t('kkm.pointAddress')" label-cols-sm="3">
                <b-form-input v-model="pointAddress" disabled></b-form-input>
            </b-form-group>
            <b-form-group :label="$t('kkm.pointAddressCity')" label-cols-sm="3">
                <multiselect v-model="selectedCity" :options="cities" :close-on-select="true" :hide-selected="true" :show-no-results="false"
                            @search-change="findCity" :internal-search="false"
                            label="name" :placeholder="$t('general.enterValue')" :select-label="''">
                    <template slot="noOptions">
                        <span>
                            {{ $t('general.enterValue' )}}
                        </span>
                    </template>
                </multiselect>
            </b-form-group>
            <b-form-group v-show="selectedCity" :label="$t('kkm.pointAddressStreet')" label-cols-sm="3">
                <multiselect v-model="selectedStreet" :options="streets" @input="addressSelected"
                            :close-on-select="true" :hide-selected="true" :show-no-results="false"
                            @search-change="findAddress" :internal-search="false"
                            label="name" :placeholder="$t('general.enterValue')" :select-label="''">
                    <template slot="noOptions">
                        <span>
                            {{ $t('general.enterValue' )}}
                        </span>
                    </template>
                </multiselect>
            </b-form-group>
            <b-form-group v-show="selectedStreet" :label="$t('kkm.pointAddressHouse')" label-cols-sm="3">
                <vue-bootstrap-typeahead v-model="formData.salePointAddressHome" :data="houses" :serializer="h => h.name"
                    :min-matching-chars="1" />
            </b-form-group>
            <b-form-group :label="$t('kkm.timezone')" label-cols-sm="3">
                <b-form-input v-model="formData.timezone" required type="number"></b-form-input>
            </b-form-group>
            <b-form-row class="justify-content-end mx-0">
                <b-button type="submit" variant="success" :disabled="isDisabled">
                    <save-icon title="" />&nbsp;{{ $t('general.save') }}
                </b-button>
            </b-form-row>
        </b-form>
    </b-card>
</template>
<script>
/* eslint-disable */
import AppData from '@/utils/appdata';
import { executeAfterTwoSeconds } from '@/utils/utils';

export default {
    name: 'KkmSetPointForm',
    mixins: [ AppData ],
    props: {
        kkmId: Number,
        pointTitle: String,
        pointAddress: String,
        timezone: String
    },
    data () {
        return {
            formData: {
                id: this.kkmId,
                salePointTitle: this.pointTitle,
                salePointAddressId: null,
                salePointAddressHome: null,
                timezone: new Date('1970-01-01T' + this.timezone).getHours()
            },
            selectedCity: null,
            selectedStreet: null,
            cities: [],
            streets: [],
            houses: []
        }
    },
    computed: {
        isDisabled: function () {
            return this.$store.getters.isLoading
        }
    },
    methods: {
        findCity: executeAfterTwoSeconds(function(query) {
            if (query.length < 3)
                return;

            const request = {
                data: { address: query },
                onSuccess: cities => this.cities = cities,
                onError: this.displayAlert 
            };

            this.$request.getCities(this, request);
        }),
        findAddress: executeAfterTwoSeconds(function (query) {
            if (query.length < 3)
                return;

            const request = {
                data: { 
                    address: query,
                    parentId: this.selectedCity.pointId 
                },
                onSuccess: streets => this.streets = streets,
                onError: this.displayAlert 
            };

            this.$request.getStreets(this, request);
        }),
        addressSelected: executeAfterTwoSeconds(function (house) {
            this.formData.parentId = house != null 
                ? house.id 
                : null;
            
            const request = {
                data: { parentId: this.formData.parentId },
                onSuccess: houses => this.houses = houses,
                onError: this.displayAlert 
            };

            this.$request.getHouses(this, request);
        }),
        setPoint: function () {
            this.hideAlert()
            if (this.formData.parentId !== null && (this.formData.salePointAddressHome === null || this.formData.salePointAddressHome.trim() === '')) {
                this.displayAlert('addressMustBeSet')
                return
            }

            this.formData.salePointAddressId = this.formData.parentId;

            this.$request.sendRequest(this, this.$appConfig.apiUrls.kkm.setPoint,
                this.formData, result => {
                    this.showSuccessAlert = true
                    this.alert = this.$i18n.t('kkm.pointSetMessage')
                }, this.displayAlert)
        }
    }
}
</script>
